import { render } from "./WithdrawConfirmationForm.vue?vue&type=template&id=ecf470ec&scoped=true"
import script from "./WithdrawConfirmationForm.vue?vue&type=script&lang=js"
export * from "./WithdrawConfirmationForm.vue?vue&type=script&lang=js"

import "./WithdrawConfirmationForm.vue?vue&type=style&index=0&id=ecf470ec&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecf470ec"]])

export default __exports__